module.exports = __webpack_public_path__ + "az.no1.0f46db0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/az.no1.jpg
// module id = aL0E
// module chunks = 0